import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../services/storage.service'
import Code from '../views/Code.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

import Customers from  '../views/Customers.vue'
import Customer from  '../views/Customer.vue'
import NewCustomer from '../views/NewCustomer.vue'

import Cleaners from  '../views/Cleaners.vue'
import Cleaner from  '../views/Cleaner.vue'

import Users from  '../views/Users.vue'
import User from '../views/User.vue'
import NewUser from '../views/NewUser.vue'

import Chemicals from '../views/Chemicals.vue'
import Chemical from '../views/Chemical.vue'

import Jobs from '../views/Jobs.vue'
import Job from '../views/Job.vue'
import NewJob from '../views/NewJob.vue'

import Schedule from '../views/Schedule.vue'
import Schedules from '../views/Schedules.vue'
import NewSchedule from '../views/NewSchedule.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/newcustomer',
    name: 'New Customer',
    component: NewCustomer,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/customer/:id',
    name: 'Customer',
    component: Customer,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/customers/get',
      title: 'Customer',
      key: 'customer'
    }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/customers/all?page=',
      title: 'All Customers',
      key: 'all'
    }
  },
  {
    path: '/newuser',
    name: 'New User',
    props: true,
    component: NewUser,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/cleaners',
    name: 'Cleaners',
    component: Cleaners,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/cleaners/all?page=',
      title: 'All Cleaners',
      key: 'all'
    }
  },
  {
    path: '/cleaner/:id',
    name: 'Cleaner',
    component: Cleaner,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/cleaner/get',
      title: 'Cleaner',
      key: 'cleaner'
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/users/all?page=',
      title: 'All Users',
      key: 'all'
    }
  },
  {
    path: '/user/:id',
    name: 'User',
    component: User,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/users/get',
      title: 'User',
      key: 'user'
    }
  },
  {
    path: '/code',
    name: 'Code',
    component: Code,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/chemicals',
    name: 'Chemicals',
    component: Chemicals,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/chemicals/all?page=',
      title: 'All Chemicals',
      key: 'all'
    }
  },
  {
    path: '/chemical/:id',
    name: 'Chemical',
    component: Chemical,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/chemical/get',
      title: 'Chemical',
      key: 'chemical'
    }
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: Jobs,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/jobs/all?page=',
      title: 'Cleaning Jobs',
      key: 'all'
    }
  },
  {
    path: '/job/:id',
    name: 'Job',
    component: Job,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/job/get',
      title: 'Job',
      key: 'job'
    }
  },
  {
    path: '/newjob',
    name: 'New Job',
    props: true,
    component: NewJob,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/schedule/:id',
    name: 'Schedule',
    component: Schedule,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'cleaners/schedule/get',
      title: 'Schedule',
      key: 'schedule'
    }
  },
  {
    path: '/newschedule',
    name: 'New Schedule',
    component: NewSchedule,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
    }
  },
  {
    path: '/schedules',
    name: 'Schedules',
    component: Schedules,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'admin/schedule/all?page=',
      title: 'Schedules',
      key: 'all'
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/dashboard')
  }
  next();
}) 

export default router